import { COLORS } from '../../../styles/constants';
import { BOM_TABLE_COLS } from '../../BomTable/constants';
import { OP_VALUES_TABLE_COLS } from '../../OperatingValues/constants';
import { cleanupHtmlFromString, fixUnrecognizedChar } from '../../OperatingValues/utils';

export const generateBomTableBody = bomItems => {
	const formattedBOM = [];
	let elementCols = [];
	let attributes = [];
	const tableCols = BOM_TABLE_COLS.filter(col => col.pdfExport);

	tableCols.forEach(col => {
		elementCols.push({
			text: col.label + ' ' + col.unit,
			style: 'tableHeader'
		});
	});
	formattedBOM.push(elementCols);
	elementCols = [];

	bomItems.forEach(bomElement => {
		const datasheetLink = bomElement.datasheetLink;

		tableCols.forEach(col => {
			if (bomElement[col.key] === null) {
				elementCols.push('');
			} else if (col.key === 'partNumber' && datasheetLink) {
				elementCols.push({
					text: bomElement[col.key],
					link: datasheetLink,
					style: { color: COLORS.LINK__HEX }
				});
			} else if (col.key === 'attributes') {
				attributes = [];

				bomElement[col.key].forEach(att => {
					attributes.push({ text: cleanupHtmlFromString(att.formatted) });
				});

				elementCols.push({
					stack: attributes
				});
			} else {
				elementCols.push({
					text: bomElement[col.key],
					alignment: col.numeric ? 'right' : 'left'
				});
			}
		});

		formattedBOM.push(elementCols);
		elementCols = [];
	});

	return formattedBOM;
};

export const generateOpValuesTableBody = opValueCategories => {
	const formattedOPVals = [];
	let elementCols = [];

	for (const [, value] of Object.entries(OP_VALUES_TABLE_COLS)) {
		elementCols.push({ text: value.label, style: 'tableHeader' });
	}

	formattedOPVals.push(elementCols);
	elementCols = [];

	/* Get all op. values */
	let opvIndex;
	const allOpValues = [];

	opValueCategories.forEach(opvCategory => {
		opvCategory.operatingValues.forEach(opv => {
			opvIndex = allOpValues.findIndex(o => o.label === opv.label);

			if (opvIndex === -1) {
				allOpValues.push(opv);
			}
		});
	});
	const allOpValuesHtmlFormat = allOpValues.map(val => ({
		...val,
		label: cleanupHtmlFromString(val.label),
		value: fixUnrecognizedChar(val.value)
	}));
	allOpValuesHtmlFormat.forEach(opvElement => {
		OP_VALUES_TABLE_COLS.forEach(col => {
			if (opvElement[col.key] === 'ICThetaJAEffective') {
				elementCols.push({
					text: 'IC effective Theta_JA'
				});
			} else {
				elementCols.push({
					text: opvElement[col.key]
				});
			}
		});
		formattedOPVals.push(elementCols);
		elementCols = [];
	});

	return formattedOPVals;
};

export const adaptSchematicElementDimensions = exporting => {
	const schematicDOM = document.getElementById('schematic_el');
	if (schematicDOM === null) {
		return;
	}

	if (exporting) {
		schematicDOM.setAttribute('width', schematicDOM.parentNode.offsetWidth);
		schematicDOM.setAttribute('height', schematicDOM.parentNode.offsetHeight);
		return schematicDOM.outerHTML;
	}

	schematicDOM.setAttribute('width', '100%');
	schematicDOM.setAttribute('height', '100%');
};

export const adaptChartElementsDimensions = (exporting, chartIds) => {
	let chartDOM;
	// Let exportIconDOM;

	chartIds.forEach(chartId => {
		/* Chart export temporarily hidden */
		/* exportIconDOM = document
             .getElementById(chartId)
             .getElementsByClassName('amcharts-amexport-icon')[0]; */

		chartDOM = document.getElementById(chartId).getElementsByTagName('svg')[0];

		if (chartDOM.hasAttribute('xmlns')) {
			if (exporting) {
				chartDOM.setAttribute('width', chartDOM.parentNode.parentNode.offsetWidth);
				chartDOM.setAttribute('height', chartDOM.parentNode.parentNode.offsetHeight);

				// ExportIconDOM.style.visibility = 'hidden';
			} else {
				chartDOM.removeAttribute('width');
				chartDOM.removeAttribute('height');

				// ExportIconDOM.style.visibility = 'visible';
			}
		}
	});
};
